import React, { useCallback } from 'react';
import ListRow from 'screens/Panel/screens/Firm/screens/Managers/components/List/ListRow';
import { Action, Row, SelectRowAction } from 'components/List/types';

import styles from 'screens/Panel/screens/Firm/screens/Managers/components/List/List.module.scss';

type Props = {
  labels: string[];
  rows: Row[];
  onAction: Action;
  addNewLabel?: string;
  onAddNewItem?: Action;
  onRowSelect?: SelectRowAction;
};

const List: React.FC<Props> = ({ labels, rows, onAction }: Props) => {
  const getRows = useCallback((): Row[] => {
    return rows;
  }, [rows]);

  return (
    <>
      <div className={styles.table_container}>
        <table className={styles.table} cellSpacing="0">
          <thead className={styles.thead}>
            <tr className={styles.thead_tr}>
              {labels.map((label: string, index: number) => {
                return (
                  <th key={`header-label-${index}`} className={styles.thead_th}>
                    <div>{label}</div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className={styles.tbody}>
            {getRows().map((row: Row, index: number) => (
              <ListRow key={row.key ? row.key : index} items={row.data} onClick={() => {}} />
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default List;
